import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import FormatPaint from "@material-ui/icons/FormatPaint";
import OpacityTwoToneIcon from '@material-ui/icons/OpacityTwoTone';
import WarningIcon from '@material-ui/icons/Warning';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

class ProductSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div id="about" className={classes.section}>
      <div id="aboutAnchor" style={{position: "relative",top: "-150px"}} />
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>Let's talk product</h2>
            <h5 className={classes.description}>
               No jobs are small for us, we handle painting projects which would be a small Residential Re-Painting work to a medium sized commercial properties. We keep ourselves thriving for more challenging jobs. Our services are not limited but ever evolving.
            </h5>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Skilled Painters"
                description=" All our Painters have the necessary skill, license, qualification & the insurance required to carry out the job."
                icon={FormatPaint}
                iconColor="info"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Paints"
                description=" Only high quality & reliable paints are used for doing any jobs. All the paints are applied as per the manufacture’s instruction and directions."
                icon={OpacityTwoToneIcon}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="WHS"
                description=" We believe not only in protecting the health of our contractors who are working for us but also take uttermost care in protecting the environment & the ever changing situations around the work place."
                icon={WarningIcon}
                iconColor="danger"
                vertical
              />
            </GridItem>

          </GridContainer>

          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
            <h5 className={classes.description}>
               No one job is of similar kind and being mindful of this fact, our team of professional painters delivers the project by taking into consideration the business environment and the business standards which helps you to improve the look of your business in several ways. Our team of expert painters takes into consideration your affordability and budget before starting any projects.
            </h5>
            </GridItem>
          </GridContainer>

        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);
